import { useEffect } from 'react';

interface SchemaOrgProps {
  schema: Record<string, unknown>;
}

export default function SchemaOrg({ schema }: SchemaOrgProps) {
  useEffect(() => {
    let script = document.getElementById('schema-org') as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = 'schema-org';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }

    const existing = document.querySelectorAll('script[type="application/ld+json"]');
    existing.forEach((el) => {
      if (el.id !== 'schema-org') el.remove();
    });

    script.textContent = JSON.stringify(schema);
  }, [schema]);

  return null;
}